import {combineDateAndTime, combineTime} from "../shared/lib/combineDateTime/combineDateTime";

export const CalendarEventCreateSerializer = (formValues) => {
    const {description, date, duration, time, ...rest} = formValues;
    const endTime = combineTime(time, duration)
    const start = combineDateAndTime(date, time)
    const end = combineDateAndTime(date, endTime)

    return {
        title: description,
        start,
        end,
        description,
        date,
        duration,
        time,
        ...rest
    }
}